import { InputProps, Typography } from 'antd';
import React, { memo, useState } from 'react';
import './AppMultiEmailsInput.scss';
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import 'react-multi-email/dist/style.css';
import { t } from 'helpers/i18n';

type AppMultiEmailsInputProps = InputProps & {
  containerClassName?: string;
  label: string;
  emails: string[];
  placeholder?: string;
  onChanged?: (newEmails: string[]) => void;
  onValidationChanged: (isValid: boolean) => void;
};

const AppMultiEmailsInput: React.FC<AppMultiEmailsInputProps> = ({
  containerClassName,
  label,
  emails,
  placeholder,
  onChanged,
  onValidationChanged,
  ...rest
}) => {
  const [error, setError] = useState('');

  return (
    <div className={`app-input-text-container ${containerClassName}`}>
      <p className="app-input-text-label">
        {label}
        <span className="app-input-text-required">{rest.required && ' *'}</span>
      </p>
      <ReactMultiEmail
        className="form-input"
        placeholder={placeholder}
        emails={emails}
        onChange={(_emails: string[]) => {
          onChanged && onChanged(_emails);
          onValidationChanged && onValidationChanged(true);
        }}
        onChangeInput={(value: string) => {
          if (value) {
            setError(
              t('build_and_release_build_app_popup_confirm_email_instruction')
            );
            onValidationChanged && onValidationChanged(false);
          } else {
            setError('');
            onValidationChanged && onValidationChanged(true);
          }
        }}
        validateEmail={(email: string) => {
          if (isEmail(email)) {
            setError('');
            return true;
          } else {
            setError(t('build_and_release_build_app_popup_wrong_email_format'));
            return false;
          }
        }}
        getLabel={(email, index, removeEmail) => {
          return (
            <div data-tag key={index}>
              <div data-tag-item>{email}</div>
              <span data-tag-handle onClick={() => removeEmail(index)}>
                ×
              </span>
            </div>
          );
        }}
      />
      {error && (
        <p>
          <Typography.Text type="danger">{error}</Typography.Text>
        </p>
      )}
    </div>
  );
};

export default memo(AppMultiEmailsInput);
